import { isSameId } from "../../helpers";
export default function (store, { cardId, id }) {
    if (cardId) {
        const state = store.getState();
        if (!id || !cardId) {
            return;
        }
        let originalComment = {};
        const cards = state.cards.map(c => {
            if (isSameId(c.id, cardId)) {
                return {
                    ...c,
                    comments: (c.comments || []).filter(c => {
                        if (isSameId(c.id, id)) {
                            originalComment = { ...c };
                            return false;
                        }
                        return true;
                    }),
                };
            }
            return c;
        });
        store.setState({ cards });
        return () => {
            store.in.exec("add-comment", {
                id,
                cardId,
                comment: originalComment,
                $meta: { skipHistory: true },
            });
        };
    }
}
//# sourceMappingURL=delete.js.map